import {
  createNewAISummaryJob,
  deleteAiSummary,
  getAISummaryJobs,
  getSourceTypes,
  navigateSummarization,
  retryAiSummary,
} from '../../../api/endpoints/aiSummarizationApi';
import {useMutation, useQuery} from '@tanstack/react-query';
import {
  IAISummarizeJobResponse,
  IAISummaryJobsPayload,
  ICreateAISummaryJobPayload,
  ISummarizationNavigationPayload,
  ISummarizationNavigationResponse,
} from '../../../api/types/aiSummarization.type';

export const useDeleteSummarizesJob = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: deleteAiSummary,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useRetrySummarizesJob = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: retryAiSummary,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetSummarizesJobs = (payload: IAISummaryJobsPayload) => {
  return useQuery<IAISummarizeJobResponse, Error>({
    queryKey: ['getDistributedDocs', payload],
    queryFn: () => getAISummaryJobs(payload),
  });
};

export const useNavigationSummarize = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<
    ISummarizationNavigationResponse,
    Error,
    ISummarizationNavigationPayload
  >({
    mutationFn: navigateSummarization,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};

export const useGetSourceTypes = (payload: string) => {
  return useQuery<any, Error>({
    queryKey: ['getSourceTypes', payload],
    queryFn: () => getSourceTypes(payload),
  });
};

export const useCreateNewSummarizeJob = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<any, Error, any>({
    mutationFn: createNewAISummaryJob,
    mutationKey: ['createNewAISummaryJob'],
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
